import { Platform } from 'react-native';

type SplashModule = {
  preventAutoHideAsync: () => Promise<boolean>;
  hideAsync: () => Promise<boolean>;
};

let splashModule: SplashModule | null | undefined;
let hideStarted = false;
const hiddenListeners = new Set<() => void>();

function getSplashModule(): SplashModule | null {
  if (splashModule !== undefined) {
    return splashModule;
  }

  if (Platform.OS === 'web') {
    splashModule = null;
    return splashModule;
  }

  try {
    splashModule = require('expo-splash-screen') as SplashModule;
  } catch (error) {
    console.warn('expo-splash-screen is unavailable:', error);
    splashModule = null;
  }

  return splashModule;
}

export function subscribeSplashHidden(listener: () => void): () => void {
  if (hideStarted) {
    listener();
    return () => undefined;
  }

  hiddenListeners.add(listener);
  return () => {
    hiddenListeners.delete(listener);
  };
}

export async function preventNativeSplashAutoHide(): Promise<void> {
  const splash = getSplashModule();
  if (!splash) {
    return;
  }

  try {
    await splash.preventAutoHideAsync();
  } catch (error) {
    console.warn('Failed to prevent native splash auto-hide:', error);
  }
}

export function hideNativeSplash(): void {
  if (hideStarted) {
    return;
  }

  hideStarted = true;

  hiddenListeners.forEach((listener) => listener());
  hiddenListeners.clear();

  const splash = getSplashModule();
  if (!splash) {
    return;
  }

  splash.hideAsync().catch((error) => {
    console.warn('Failed to hide native splash:', error);
  });
}

if (Platform.OS !== 'web') {
  void preventNativeSplashAutoHide();
}
